import { BLOG_CONTROL_D_DOMAIN, DOCS_CONTROL_D_DOMAIN } from 'gatsby-env-variables'
import { noRedirectHomePagePath } from 'layouts'

export interface FooterLink {
  text: string
  to: string
  isExternal?: boolean
}

export interface FooterAction {
  title: string
  to: string
}

export interface FooterSection {
  title: string
  links: FooterLink[]
  actions?: FooterAction[]
}

export interface FooterLinks {
  general: FooterSection
  features: FooterSection
  industries: FooterSection
  resources: FooterSection
}

const general = [
  {
    text: 'About Us',
    to: '/about-us',
  },
  {
    text: 'Pricing',
    to: '/pricing',
  },
  {
    text: 'Personal Use',
    to: `/personal${noRedirectHomePagePath}`,
  },
  {
    text: 'Free DNS',
    to: '/free-dns',
  },
  {
    text: 'Help',
    to: '/',
    isExternal: true,
  },
  {
    text: 'Privacy',
    to: 'https://controld.com/privacy',
  },
  {
    text: 'Terms',
    to: 'https://controld.com/terms',
  },
  {
    text: 'Security & Trust',
    to: '/compliance',
  },
]

const features = [
  {
    text: 'Malware Blocking',
    to: '/features/malware-blocking',
  },
  {
    text: 'Modern Protocols',
    to: '/features/modern-protocols',
  },
  {
    text: 'Web Filtering',
    to: '/features/web-filtering',
  },
  {
    text: 'Service Filtering',
    to: '/features/service-filtering',
  },
  {
    text: 'Custom Filtering',
    to: '/features/custom-filtering',
  },
  {
    text: 'Content Filtering',
    to: '/features/content-filtering',
  },
  {
    text: 'DNS Filtering',
    to: '/features/dns-filtering',
  },
  {
    text: 'Multi-Tenancy',
    to: '/features/multi-tenancy',
  },

  {
    text: 'Data Streaming (SIEM)',
    to: '/features/data-streaming-siem',
  },

  {
    text: 'Analytics',
    to: '/features/analytics',
  },
  {
    text: 'Admin Logs',
    to: '/features/admin-logs',
  },
  {
    text: 'Traffic Redirection',
    to: '/features/traffic-redirection',
  },
  {
    text: 'Integrations',
    to: '/features/integrations',
  },
]

const industries = [
  {
    text: 'Enterprise',
    to: '/industries/enterprise',
  },
  {
    text: 'MSPs',
    to: '/industries/msps',
  },
  {
    text: 'SMBs',
    to: '/industries/smbs',
  },
  {
    text: 'Startups',
    to: '/industries/startups',
  },
  {
    text: 'Non-Profits',
    to: '/industries/non-profits',
  },
  {
    text: 'Education',
    to: '/industries/schools',
  },
  {
    text: 'Hospitality',
    to: '/industry-airbnb-hosts',
    isExternal: true,
  },
  {
    text: 'Faith Based Orgs',
    to: '/industries/faith-based-organizations',
  },
  {
    text: 'Public Wi-Fi',
    to: '/industries/public-wifi-operators',
  },
]

const resources = [
  {
    text: 'Knowledge Base',
    to: '/',
    isExternal: true,
  },
  {
    text: 'API Docs',
    to: `${DOCS_CONTROL_D_DOMAIN}/reference`,
    isExternal: true,
  },
  {
    text: 'Blog',
    to: `${BLOG_CONTROL_D_DOMAIN}`,
    isExternal: true,
  },
  {
    text: 'Network',
    to: '/network',
  },
  {
    text: 'Changelog',
    to: `${DOCS_CONTROL_D_DOMAIN}/changelog`,
  },
  {
    text: 'Status',
    to: '/status',
  },
  {
    text: 'Support',
    to: '/contact',
  },
]

export const footerLinks: FooterLinks = {
  general: {
    title: 'General',
    links: general,
    actions: [
      {
        title: 'Log in',
        to: '/login',
      },
      {
        title: 'Sign Up',
        to: '/onboard',
      },
      {
        title: 'Go to Dashboard',
        to: '/dashboard',
      },
    ],
  },
  features: {
    title: 'Features',
    links: features,
  },
  industries: {
    title: 'Industries',
    links: industries,
  },
  resources: {
    title: 'Resources',
    links: resources,
  },
}
